import styled from 'styled-components'

const ProductHeroSectionStyle = styled.div`
    --phsContPaddingBottom: var(--sp15x);
    --phsBtnMarginTop: var(--sp6x);
    --phsBtnMarginBottom: var(--sp8x);
    --phsImageWidth: 69.03%;
    --phsImageProportion: 135%;
    --phsImageMarginBottom: 0;
    --phsCollectionMarginBottom: var(--sp3x);
    --phsNameMarginBottom: var(--sp3x);
    --phsTextMarginBottom: var(--sp10x);
    --phsAvailableTitleMarginBottom: var(--sp3x);
    --phsAvailableTextMarginBottom: 0;
    --phsAlcoholTitleMarginBottom: var(--sp2x);
    --phsCircleSize: var(--sp6x);
    --phsCircleMarginRight: var(--sp2-5x);

    padding-bottom: var(--phsContPaddingBottom);

    .phs-back-btn {
        margin-top: var(--phsBtnMarginTop);
        margin-bottom: var(--phsBtnMarginBottom);
    }

    .phs-cont {

        .phs-image-col {
            display: flex;
            justify-content: center;
            margin-bottom: var(--phsImageMarginBottom);

            .phs-image-cont {
                width: var(--phsImageWidth);

                .image-cont {
                    --proportion: var(--phsImageProportion);
                    border-radius: var(--borderRadiusSize);
                    overflow: hidden;
                }
            }
        }
        
        .phs-info-col {
            display: flex;
            flex-direction: column;
            justify-content: center;

            .phs-info-cont {

                .phs-collection {
                    margin-bottom: var(--phsCollectionMarginBottom);
                }
                
                .phs-name {
                    margin-bottom: var(--phsNameMarginBottom);
                }
                
                .phs-text {
                    margin-bottom: var(--phsTextMarginBottom);
                }

                .phs-about-product {

                    .phs-available-title {
                        margin-bottom: var(--phsAvailableTitleMarginBottom);
                    }

                    .phs-available-text {
                        display: flex;
                        flex-wrap: wrap;
                        white-space: break-spaces;
                        margin-bottom: var(--phsAvailableTextMarginBottom);
                    }

                    .phs-alcohol-title {
                        margin-bottom: var(--phsAlcoholTitleMarginBottom);
                    }

                    .phs-alcohol-info-cont {

                        .phs-alcohol-text {
                            display: flex;
                            align-items: center;

                            .phs-circle {
                                width: var(--phsCircleSize);
                                height: var(--phsCircleSize);
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                margin-right: var(--phsCircleMarginRight);
                                border-radius: 50%;
                                background: var(--primaryColor9);
                                color: var(--white);
                            }
                        }                        
                    }
                }
            }
        }
    }
    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
        --phsContPaddingBottom: var(--sp11x);
        --phsBtnMarginTop: var(--sp4x);
        --phsBtnMarginBottom: var(--sp5x);
        --phsImageWidth: 69.91%;
        --phsCollectionMarginBottom: var(--sp2x);
        --phsNameMarginBottom: var(--sp1x);
        --phsTextMarginBottom: var(--sp8x);
        --phsAvailableTitleMarginBottom: var(--sp3x);
        --phsAlcoholTitleMarginBottom: var(--sp2x);
        --phsCircleSize: var(--sp5x);
        --phsCircleMarginRight: var(--sp1x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
        --phsContPaddingBottom: var(--sp17x);
        --phsBtnMarginTop: var(--sp3x);
        --phsBtnMarginBottom: var(--sp7x);
        --phsImageWidth: 71.11%;
        --phsCollectionMarginBottom: var(--sp2x);
        --phsNameMarginBottom: var(--sp2x);
        --phsTextMarginBottom: var(--sp8x);
        --phsAvailableTitleMarginBottom: var(--sp3x);
        --phsAlcoholTitleMarginBottom: var(--sp2x);
        --phsCircleSize: var(--sp5x);
        --phsCircleMarginRight: var(--sp1-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
        --phsContPaddingBottom: var(--sp9x);
        --phsBtnMarginTop: var(--sp2x);
        --phsBtnMarginBottom: var(--sp4x);
        --phsImageWidth: 70.03%;
        --phsCollectionMarginBottom: var(--sp2x);
        --phsNameMarginBottom: var(--sp2x);
        --phsTextMarginBottom: var(--sp7x);
        --phsAvailableTitleMarginBottom: var(--sp3x);
        --phsAlcoholTitleMarginBottom: var(--sp2x);
        --phsCircleSize: var(--sp5x);
        --phsCircleMarginRight: var(--sp1x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
        --phsContPaddingBottom: var(--sp7x);
        --phsBtnMarginTop: var(--sp2x);
        --phsBtnMarginBottom: var(--sp4x);
        --phsImageWidth: 82.43%;
        --phsCollectionMarginBottom: var(--sp2x);
        --phsNameMarginBottom: var(--sp2x);
        --phsTextMarginBottom: var(--sp6x);
        --phsAvailableTitleMarginBottom: var(--sp3x);
        --phsAlcoholTitleMarginBottom: var(--sp2x);
        --phsCircleSize: var(--sp5x);
        --phsCircleMarginRight: var(--sp1x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
        --phsContPaddingBottom: var(--sp9x);
        --phsBtnMarginTop: var(--sp3x);
        --phsBtnMarginBottom: var(--sp6x);
        --phsImageWidth: 65.53%;
        --phsCollectionMarginBottom: var(--sp1-5x);
        --phsNameMarginBottom: var(--sp1-5x);
        --phsTextMarginBottom: var(--sp6x);
        --phsAvailableTitleMarginBottom: var(--sp3x);
        --phsAvailableTextMarginBottom: var(--sp4x);
        --phsAlcoholTitleMarginBottom: var(--sp2x);
        --phsCircleSize: var(--sp5x);
        --phsCircleMarginRight: var(--sp1-5x);
	}

    @media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        .phs-cont {
            .phs-image-col {
                justify-content: center;
            }

        }
    }

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        --phsContPaddingBottom: var(--sp8x);
        --phsBtnMarginTop: var(--sp2x);
        --phsBtnMarginBottom: var(--sp3x);
        --phsImageWidth: 65.53%;
        --phsImageMarginBottom: var(--sp3x);
        --phsCollectionMarginBottom: var(--sp1-5x);
        --phsNameMarginBottom: var(--sp1-5x);
        --phsTextMarginBottom: var(--sp6x);
        --phsAvailableTitleMarginBottom: var(--sp3x);
        --phsAlcoholTitleMarginBottom: var(--sp2x);
        --phsCircleSize: var(--sp5x);
        --phsCircleMarginRight: var(--sp1x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
        --phsContPaddingBottom: var(--sp8x);
        --phsBtnMarginTop: var(--sp3x);
        --phsBtnMarginBottom: var(--sp2x);
        --phsImageWidth: 100%;
        --phsImageMarginBottom: var(--sp4x);
        --phsCollectionMarginBottom: var(--sp1-5x);
        --phsNameMarginBottom: var(--sp1-5x);
        --phsTextMarginBottom: var(--sp4x);
        --phsAvailableTitleMarginBottom: var(--sp2x);
        --phsAvailableTextMarginBottom: var(--sp4x);
        --phsAlcoholTitleMarginBottom: var(--sp2x);
        --phsCircleSize: var(--sp5x);
        --phsCircleMarginRight: var(--sp1x);
	}
`

export default ProductHeroSectionStyle